import { render } from "./MediaTypes.vue?vue&type=template&id=19b1a800&scoped=true"
import script from "./MediaTypes.vue?vue&type=script&lang=js"
export * from "./MediaTypes.vue?vue&type=script&lang=js"

import "./MediaTypes.vue?vue&type=style&index=0&id=19b1a800&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b1a800"]])

export default __exports__